import OnboardingAnalyticsHome from '../../components/onboarding/OnboardingAnalyticsHome';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import { store } from 'store/createStore';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../../consts';

import { fetchUsersInteraction, setShowAnonymousUsers } from '../../modules';
import API from '../../../../../utils/api';

const mapDispatchToProps = dispatch => ({
  fetchUsersInteraction(listUsersWithData, from, to, userAnonymous) {
    dispatch(fetchUsersInteraction(listUsersWithData, from, to, userAnonymous));
  },
  setShowAnonymousUsers(data) {
    dispatch(setShowAnonymousUsers(data));
  },
});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
    listInteractions: _.get(state, 'analytics.listInteractions', []),
    listUsersInteraction: _.get(state, 'analytics.listUsersInteraction', []),
    showAnonymousUsers: _.get(state, 'analytics.showAnonymousUsers', true),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('selectedTab', 'updateSelectedTab', 0),
  withState('momentsList', 'setMomentsList', []),
  withState('tableData', 'setTableData', []),
  withState('createAccountClicks', 'setCreateAccountClicks', 0),
  withState('onboardingCompleted', 'setOnboardingCompleted', 0),
  withState('setupAccount', 'setSetupAccount', 0),
  withState(
    'completedAcctSetupPercentage',
    'setCompletedAcctSetupPercentage',
    0
  ),
  withState(
    'completedOnboardingPercentage',
    'setCompletedOnboardingPercentage',
    0
  ),
  withState(
    'onboardingProgressAnalytics',
    'setOnboardingProgressAnalytics',
    []
  ),
  withHandlers({
    onChangeTab: props => (evt, value) => {
      props.updateSelectedTab(value);
    },
    getOnboardingProgressAnalytics: props => () => {
      const { currentGroup } = store.getState().auth;
      API.getOnboardingAnalytics({
        group: currentGroup._id,
      }).then(onboardingData => {
        const {
          data,
          createAccountClicks,
          completedAcctSetup,
          completedOnboarding,
          completedAcctSetupPercentage,
          completedOnboardingPercentage,
        } = onboardingData;

        let rowCliks = {};
        let rowPercentage = {};
        data.forEach((data, idx) => {
          rowCliks[idx] = data.clicks;
          if (data.percentateFromPrevious) {
            rowPercentage[idx] = data.percentateFromPrevious + '%';
          }
        });

        let tableData = [rowCliks, rowPercentage];
        props.setOnboardingProgressAnalytics(data);
        props.setTableData(tableData);
        props.setCreateAccountClicks(createAccountClicks);
        props.setOnboardingCompleted(completedOnboarding);
        props.setSetupAccount(completedAcctSetup);
        props.setCompletedAcctSetupPercentage(completedAcctSetupPercentage);
        props.setCompletedOnboardingPercentage(completedOnboardingPercentage);
      });
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.ANALYTICS);
    },
    componentDidMount() {
      this.props.getOnboardingProgressAnalytics();
    },
  })
);

export default enhance(OnboardingAnalyticsHome);
